class Tawk {
  constructor(tawk_c) {
    window.Tawk_API = window.Tawk_API || {}, window.Tawk_LoadStart = new Date();

    let s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
    s1.async = true;
    s1.src = `https://embed.tawk.to/${tawk_c}/default`;
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');
    s0.parentNode.insertBefore(s1, s0);
  }
}

export default Tawk;



// WEBPACK FOOTER //
// ./src/services/tawk.js